import React, { useState } from "react";
import "./FilterTabs.css"; // Import the CSS file

// Sample data for the tabs. You can replace this with your own data.
const initialTabs = [
  { id: "all", label: "All", count: 47 },
  { id: "z-17", label: "Z-17", count: 12 },
  { id: "lv", label: "LV", count: 8 },
  { id: "catalog", label: "Catalog", count: 1 },
  { id: "eurocode", label: "Eurocode", count: 18 },
  { id: "other", label: "Other", count: 8 },
];

const FilterTabs = () => {
  const [activeTabId, setActiveTabId] = useState(initialTabs[0].id);

  const handleTabClick = (tabId) => {
    setActiveTabId(tabId);
    // You can add logic here to filter content based on the activeTabId
    console.log(`Active tab changed to: ${tabId}`);
  };

  return (
    <div className="filter-tabs-container" role="group" aria-label="Document filter">
      {initialTabs.map((tab) => {
        const active = activeTabId === tab.id;
        return (
          <button
            key={tab.id}
            type="button"
            className={`ds-chip${active ? " is-active" : ""}`}
            aria-pressed={active}
            onClick={() => handleTabClick(tab.id)}
          >
            <span>{tab.label}</span>{" "}
            <span className="ds-chip-count">{tab.count}</span>
          </button>
        );
      })}
    </div>
  );
};

export default FilterTabs;
